// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/channel/components/ChannelName.module.css';
import {parseChannelNameParts} from '@app/features/channel/utils/ChannelNameText';
import {buildCustomEmojiURL} from '@app/features/expressions/utils/CustomEmojiImageUrl';
import {clsx} from 'clsx';
import type React from 'react';

interface ChannelNameProps {
	name: string;
	className?: string;
}

export const ChannelName: React.FC<ChannelNameProps> = ({name, className}) => {
	const parts = parseChannelNameParts(name);
	return (
		<span className={clsx(styles.root, className)} data-flx="channel.channel-name.root">
			{parts.map((part, index) => {
				if (part.kind === 'text') {
					if (part.value.length === 0) {
						return null;
					}
					return (
						<span key={`text-${index}`} data-flx="channel.channel-name.text">
							{part.value}
						</span>
					);
				}
				return (
					<img
						key={`emoji-${part.id}-${index}`}
						className={styles.emoji}
						src={buildCustomEmojiURL({id: part.id, animated: part.animated})}
						alt={`:${part.name}:`}
						draggable={false}
						data-flx="channel.channel-name.emoji"
					/>
				);
			})}
		</span>
	);
};
